import { Skeleton } from "../Skeleton";

export function ContactDetailSkeleton() {
  return (
    <div className="space-y-6">
      <div className="panel flex items-center gap-6">
        <Skeleton variant="circle" size={80} />
        <div className="space-y-3 flex-1">
          <Skeleton height={28} width="40%" />
          <Skeleton height={16} width="30%" />
          <Skeleton height={16} width="60%" />
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="panel">
            <Skeleton height={12} width="50%" />
            <Skeleton height={28} width="35%" />
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-8">
        <div className="panel space-y-4">
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <Skeleton key={i} height={20} width={`${50 + ((i * 7) % 30)}%`} />
          ))}
        </div>
        <div className="panel space-y-3">
          <Skeleton height={16} width="40%" />
          <Skeleton height={14} />
          <Skeleton height={14} width="80%" />
        </div>
      </div>
    </div>
  );
}
